type IndexCode = "VL" | "L" | "M-" | "M+" | "M" | "H" | "VH"

type MorganIndexEntry = [index: IndexCode, max: number]

interface MorganIndex {
    P2O5: MorganIndexEntry[]
    K2O: MorganIndexEntry[]
    MgO: MorganIndexEntry[]
}

export function getMorganIndexTextFromValue(nutrient: keyof (MorganIndex), mgl: number) {
    const entry = getMorganIndex(nutrient, mgl)
    return entry ? entry[0] : undefined
}

/**
 * Returns the index matching a mg/l value in the Morgan index
 * @param nutrient Nutrient type
 * @param mgl Morgan value in mg/l
 * @returns Index entry
 */
export function getMorganIndex(nutrient: keyof (MorganIndex), mgl: number) {

    const a = data[nutrient]

    const match = a.find(e => mgl <= e[1]) ?? a[0]

    return match

}

const data: MorganIndex = {

    P2O5: [
        ["VL", 1.8],
        ["L", 4.5],
        ["M-", 9.5],
        ["M+", 13.5],
        ["H", 30.1],
        ["VH", Number.MAX_VALUE]
    ],

    K2O: [
        ["VL", 40],
        ["L", 76],
        ["M-", 141],
        ["M+", 201],
        ["H", 400.1],
        ["VH", Number.MAX_VALUE]
    ],

    MgO: [
        ["VL", 20],
        ["L", 61],
        ["M", 201],
        ["H", 1000.1],
        ["VH", Number.MAX_VALUE]
    ]
}


export type MorganAttribute = "P2O5" | "K2O" | "MgO"

/**
 * Checks if a property matches a Morgan attribute
 */
export function isMorganAttribute(property: string): property is MorganAttribute {

    switch (property) {

        case "P2O5":
        case "K2O":
        case "MgO":
            return true

        default:
            return false

    }
}

export function getMorganAttribute(key: string) {
    return isMorganAttribute(key)
        ? key
        : undefined
}
